.root {
  &[data-variant="light"] {
    & .placeholder {
      background-color: light-dark(
        var(--mantine-color-primary-light),
        var(--mantine-color-primaryDark-7)
      );
    }
  }
}

.placeholder {
  font-weight: 600;

  /** this is on the parent element... */
  &[data-variant="white"] {
    color: var(--mantine-color-dark-light-color);
  }
}
